// extracted by mini-css-extract-plugin
export default {"mainLayout":"AppLayoutStyles_mainLayout__UPmkQ","layout":"AppLayoutStyles_layout__Ow5Ot"};